import { Box, SxProps, Theme, Typography } from '@mui/material';
import { baseColors } from 'utils/constants';
import lineImage from 'assets/images/bridge/line.png';

type Props = {
  id?: string;
  name?: string;
  sx?: SxProps<Theme> | undefined;
  children?: React.ReactNode;
};

const BridgeTitleBar = ({ name, sx, children }: Props) => (
  <Box
    sx={{
      width: '100%',
      mx: 'auto',
      my: 0,
      p: 1,
      mt: { xs: 4, sm: 0 },
      textAlign: 'center',
      ...sx
    }}
  >
    <Typography
      variant="h4"
      sx={{
        color: baseColors.bridgeLGray,
        fontSize: '18px',
        fontWeight: 900
      }}
    >
      {name}
    </Typography>
    <img src={lineImage} alt="line" style={{ width: '20px', marginTop: '10px' }} />
    <Typography
      variant="h4"
      sx={{
        mt: 1,
        mb: 2,
        color: baseColors.bridgeDGray,
        fontSize: { xs: '20px', sm: '30px' },
        fontWeight: 700
      }}
    >
      {children}
    </Typography>
  </Box>
);

export default BridgeTitleBar;
